module.exports = __webpack_public_path__ + "static/media/_georgia.8374b1d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_georgia.svg
// module id = 2323
// module chunks = 7